import { useEffect, RefObject } from "react";

const useOutsideClick = (ref, callback, triggerRef?: RefObject<HTMLElement | HTMLDivElement | HTMLInputElement | null>) => {
    const handleClick = e => {
        // Dont run callback if it was the trigger that clicked
        if (
            typeof triggerRef !== 'undefined' &&
            triggerRef !== null &&
            triggerRef.current !== null &&
            triggerRef.current.contains(e.target)
        ) {
            return;
        }

        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    });
};

export default useOutsideClick;
